module.exports = __webpack_public_path__ + "img/config_search.30b9aa65.png";